import { PromoBlock } from './PromoBlock'
import { DEFAULT_PROMO_BLOCK } from '../../lib'

import type { HomepagePromoBlock } from '../../types'

interface PromoBlockRowProps {
  /** 1 or 2 promo blocks to render side by side (two-per-row on md+). */
  blocks: HomepagePromoBlock[]
  /** Loading state - renders skeleton cards. */
  isLoading?: boolean
  /** How many skeleton cards to show while loading (default 2). */
  skeletonCount?: number
}

/**
 * PromoBlockRow — lays promo cards out two-per-row (TSS-535).
 *
 * A thin grid wrapper: 1 column on mobile, 2 columns on md+. Consumers pass a
 * pair (or a single trailing block); this keeps the pairing/layout concern out
 * of HomepageSections.
 */
export function PromoBlockRow({ blocks, isLoading = false, skeletonCount = 2 }: PromoBlockRowProps) {
  const items = isLoading
    ? Array.from({ length: skeletonCount }, () => DEFAULT_PROMO_BLOCK)
    : blocks

  return (
    <div className="mx-auto grid w-full max-w-[1920px] grid-cols-1 gap-4 px-1 md:grid-cols-2 md:gap-6 md:px-6 xl:px-10">
      {items.map((block, index) => (
        <PromoBlock
          key={isLoading ? `promo-skeleton-${index}` : block.id}
          block={block}
          isLoading={isLoading}
        />
      ))}
    </div>
  )
}
